import { render, staticRenderFns } from "./custompageagreement.vue?vue&type=template&id=1ba194e4&scoped=true"
import script from "./custompageagreement.vue?vue&type=script&lang=js"
export * from "./custompageagreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba194e4",
  null
  
)

export default component.exports